import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useQuest } from "@/lib/quest";

export function useUrgent(enabled = true) {
  const [heart, setHeart] = useState(false);
  const [q] = useQuest(enabled ? 120000 : 0);
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => api.get("/heart").then(({ data }) => setHeart(!!data.chain?.is_holder)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [enabled]);
  const quest = q?.status === "running" && !q.excluded && new Date(q.end) - Date.now() < 86400000;
  return heart || quest;
}

export const UrgentDot = ({ on, testId }) => on ? (
  <span data-testid={testId} title="Es gibt etwas Wichtiges im Feed" className="absolute -top-1 -right-1.5 w-2.5 h-2.5 rounded-full bg-rose-600 border-2 border-white">
    <span className="absolute inset-0 rounded-full bg-rose-500 animate-ping" />
  </span>
) : null;
